"use strict";
import { addEvent } from "../addEvent/addEvent";

export const mobileMainMenu = class {
  mainContainer = false;
  showMobileMenuButton = false;
  showMobileMenuButtonId = "show-mobile-menu-button";
  hideMobileMenuButton = false;
  hideMobileMenuButtonId = "hide-mobile-menu-button";
  mobileMenuContainer = false;
  mobileMenuContainerId = "mobile-menu-container";
  showMobileMenuEnabledClass = "mobile-menu";
  showMobileMenuClass = "mobile-menu--show";

  constructor(mainContainer) {
    if (!mainContainer) {
      return false;
    }

    this.mainContainer = mainContainer;
    this._init();
    return this;
  }

  enableMenu = () => {
    const { showMobileMenuEnabledClass } = this;
    const body = document.body;
    body.classList.add(showMobileMenuEnabledClass);
    this._enable();
  };

  disableMenu = () => {
    const { showMobileMenuEnabledClass } = this;
    const body = document.body;
    body.classList.remove(showMobileMenuEnabledClass);
    this._disable();
  };

  _init = () => {
    this._createShowMobileMenuButton();
    this._createMobileMenu();
  };

  _enable = () => {
    const {
      showMobileMenuButtonId,
      mobileMenuContainerId,
      mainContainer,
    } = this;
    const mobileButton = document.getElementById(showMobileMenuButtonId);
    const mobileContainer = document.getElementById(mobileMenuContainerId);

    if (!mobileButton) {
      mainContainer.parentNode.appendChild(this.showMobileMenuButton);
    }

    if (!mobileContainer) {
      document.body.appendChild(this.mobileMenuContainer);
    }
  };

  _disable = () => {
    const {
      showMobileMenuButtonId,
      mobileMenuContainerId,
      showMobileMenuClass,
    } = this;
    const mobileButton = document.getElementById(showMobileMenuButtonId);
    const mobileContainer = document.getElementById(mobileMenuContainerId);

    document.body.classList.remove(showMobileMenuClass);

    if (mobileButton) {
      mobileButton.remove();
    }

    if (mobileContainer) {
      mobileContainer.remove();
    }
  };

  _createShowMobileMenuButton = () => {
    let showMobileMenuButton = document.createElement("a");
    showMobileMenuButton.setAttribute("id", this.showMobileMenuButtonId);
    showMobileMenuButton.title = "pokaż menu";
    showMobileMenuButton.href = `#${this.mobileMenuContainerId}`;

    let showMobileMenuButtonSpan = document.createElement("span");
    showMobileMenuButton.appendChild(showMobileMenuButtonSpan);

    showMobileMenuButtonSpan = document.createElement("span");
    showMobileMenuButton.appendChild(showMobileMenuButtonSpan);

    showMobileMenuButtonSpan = document.createElement("span");
    showMobileMenuButton.appendChild(showMobileMenuButtonSpan);

    this._showMobileMenuButtonClick(showMobileMenuButton);

    this.showMobileMenuButton = showMobileMenuButton;
  };

  _showMobileMenuButtonClick = (clikcElement) => {
    addEvent(clikcElement, "click", (e) => {
      e.preventDefault();
      const { showMobileMenuClass } = this;

      document.body.classList.add(showMobileMenuClass);
    });
  };

  _createMobileMenu = () => {
    const { mainContainer, mobileMenuContainerId } = this;
    const menu = mainContainer.querySelector("ul");
    const menu_elements = menu.getElementsByTagName("li");

    let mobileMenuContainer = document.createElement("div");
    mobileMenuContainer.setAttribute("id", mobileMenuContainerId);

    let mobileMenuList = document.createElement("ul");

    Array.from(menu_elements).forEach((elm) => {
      if (elm.parentNode === menu) {
        let li = document.createElement("li");
        let link = elm.querySelector("a").cloneNode(true);
        li.appendChild(link);
        mobileMenuList.appendChild(li);
      }
    });

    mobileMenuContainer.appendChild(mobileMenuList);

    let hideMobileMenuButton = document.createElement("a");
    hideMobileMenuButton.setAttribute("id", this.hideMobileMenuButtonId);
    hideMobileMenuButton.title = "ukryj menu";
    hideMobileMenuButton.href = `#`;

    let hideMobileMenuButtonSpan = document.createElement("span");
    hideMobileMenuButton.appendChild(hideMobileMenuButtonSpan);

    hideMobileMenuButtonSpan = document.createElement("span");
    hideMobileMenuButton.appendChild(hideMobileMenuButtonSpan);

    this._hideMobileMenuButtonClick(hideMobileMenuButton);
    mobileMenuContainer.appendChild(hideMobileMenuButton);

    this.mobileMenuContainer = mobileMenuContainer;
  };

  _hideMobileMenuButtonClick = (clikcElement) => {
    addEvent(clikcElement, "click", (e) => {
      e.preventDefault();
      const { showMobileMenuClass } = this;

      document.body.classList.remove(showMobileMenuClass);
    });
  };
};
